import store from "../store/store";
import action from "../store/actions"

import appApi from '../api/app';
import productApi from '../api/product';
import dashboardApi from "../api/dashboard";
import { generateToken } from "../notifications/firebase";
// import socketConnection from "../socket/socketConnection";

let updateListOrder = async (data) => {
   let list = await data?.map((data, index) => { return { ...data, id: index } })
   return list
}
let getAppData = () => {
   try {
      store.dispatch(action.profileLoading());
      appApi.getProfile().then(async res => {
         if (res?.data?.data && !res?.data?.error) {
            generateToken();//create FCM token
            store.dispatch(action.addProfile(res?.data?.data));
            // socketConnection.emit("login", res?.data?.data?._id);
            // *********************************************************************************
            try {
               store.dispatch(action.brandsLoading());
               // Brands ********************************
               appApi.getBrands().then(async res => {
                  if (res?.data?.data) {
                     store.dispatch(action.addBrandsList(await updateListOrder(res?.data?.data)));
                  }
               })
            } catch (error) {
               console.log("brands getting error", error.message)
            }
            // *********************************************************************************
            try {
               store.dispatch(action.pendingLoading());
               // Brands ********************************
               appApi.getPendingOrders().then(async res => {
                  if (res?.data?.data) {
                     store.dispatch(action.addPendingList(res?.data?.data));
                  }
               })
            } catch (error) {
               console.log("brands getting error", error.message)
            }
            // Category ********************************
            try {
               store.dispatch(action.categoryLoading());
               appApi.getCategories().then(async res => {
                  if (res?.data?.data) {
                     store.dispatch(action.addCategoryList(await updateListOrder(res?.data?.data)));
                  }
               })
            } catch (error) {
               console.log("brands getting error", error.message)
            }
            // Users ********************************
            try {
               store.dispatch(action.usersLoading());
               appApi.getUsers().then(async res => {
                  if (res?.data?.error == false && res?.data?.data?.data) {
                     store.dispatch(action.addUsersList(res?.data?.data));
                  }
               })
            } catch (error) {
               console.log("brands getting error", error.message)
            }
            // Product ********************************
            try {
               store.dispatch(action.productLoading());
               productApi.getProducts(1).then(async res => {
                  if (res?.data?.error == false) {
                     store.dispatch(action.addProductsList({ data: await updateListOrder(res?.data?.data?.data), pageLoaded: 1 }));
                  }
               })
            } catch (error) {
               console.log("brands getting error", error.message)
            }
            // Orders ********************************
            try {
               store.dispatch(action.ordersLoading());
               productApi.getOrders().then(async res => {
                  if (res?.data?.data) {
                     store.dispatch(action.addOrdersList({
                        data: await updateListOrder(res?.data?.data?.data),
                        page: res?.data?.data?.page,
                        limit: res?.data?.data?.perPage,
                        total: res?.data?.data?.total,
                        totalPages: res?.data?.data?.totalPages
                     }));
                  }
               })
            } catch (error) {
               console.log("brands getting error", error.message)
            }
            // Locations ********************************
            try {
               store.dispatch(action.locationsLoading());
               productApi.getLocations().then(async res => {
                  if (res?.data?.data) {
                     store.dispatch(action.addLocationsList(await updateListOrder(res?.data?.data)));
                  }
               })
            } catch (error) {
               console.log("brands getting error", error.message)
            }
            // dashboard ********************************
            try {
               store.dispatch(action.dashboardLoading());
               dashboardApi.dashboard().then(async res => {
                  if (res?.data?.data) {
                     store.dispatch(action.updateDashboard(res?.data?.data));
                  }
               })
            } catch (error) {
               console.log("brands getting error", error.message)
            }
            // *********************************************************************************
            // contact Us 
            try {
               store.dispatch(action.contactUsLoading());
               productApi.contactUsList().then(async res => {
                  if (res?.data?.data) {
                     store.dispatch(action.addContactUsList(res?.data?.data));
                  }
               })
            } catch (error) {
               console.log("contact-us getting error", error.message)
            }
            // *********************************************************************************
         }
      }).catch(error => {
         console.log(error)
         localStorage.removeItem("profile")
         localStorage.removeItem("token")
         window.location.href = "/";
      })
   } catch (error) {
      console.log({ error })
      localStorage.removeItem("profile")
      localStorage.removeItem("token")
      window.location.href = "/";
   }

}

export default getAppData



